import ReactGA from "react-ga";

import { debounce } from "@arcgis/core/core/promiseUtils";
import { navigate } from "../utils/routerHistory";
import React, { createContext, useEffect, useReducer } from "react";
import useSearch from "../hooks/useSearch";

import { AppProviderProps, AppState, ContextProps } from "../interfaces/common";
import { turnLayersVisible } from "../utils/mapHelper";
import {
  operationalLayerName,
  assessorInfo,
  operationalLayers,
  ApplicationName,
  ShowDisclaimerOnPageLoad,
} from "../appConfig";


//import Config from 'Config';

const initialState: AppState = {
  searchResultDetailsItems: null,
  assessorSearchResults: null,
  assessorSelectionResults: [],
  selectedSearchResultDetail: null,
  relatedPlanAreaDetails: [],
  baseMap: null,
  currentSearchItem: null,
  displayedSearchItems: null,
  displayedSelectedItems: [],
  currentZoomTodisplayedItems: [],
  mapHoveredHighlightItem: null,
  locationSearchResults: null,
  mapView: null,
  mode: "list",
  mounted: false,
  searchItemLayerNames: null,
  searchItems: null,
  selectedItems: null,
  searchText: "",
  sidePanelShown: true,
  selectionModeOn: true,
  displaySelectionResults: false,
  mapBusy: false,
  displayedSearchItemLayerNames: [],
  displayedSelectedItemLayerNames: [],
  selectedQuickMap: null,
  shareMUGIS: false,
  showDisclaimer: null
};

// main application context
export const AppContext = createContext<ContextProps>({
  state: initialState,
  setState: (val: any) => val,
});

// main application provider
export const AppProvider = ({ children }: AppProviderProps) => {
  //const [latLon] = useGeolocation();
  const [
    searchItems,
    searchItemLayerNames,
    displayedSearchItems,
    selectedItems,
    selectedItemLayerNameItems,
    displayedSelectedItems,
    fetchSearchItems,
    fetchSelectedItems,
  ] = useSearch();
  const reducer: (a: AppState, b: AppState) => AppState = (
    currentState,
    newState
  ) => ({ ...currentState, ...newState });
  const init: (a: AppState) => AppState = (initState) => ({
    ...initState,
    searchItems,
    displayedSearchItems,
    searchItemLayerNames,
  });
  const [state, setState] = useReducer(reducer, initialState, init);

  const selectSearchItem = async () => {
    if (state.mode === "list") {
      //navigate("/map");
    }
    const app = await import("../data/map");
    if (state.mode === "normal") {
      const features = await app.querySearchItems(
        state.currentSearchItem as any
      );
      await app.selectSearchItems(features);
    } else {
      // need to debounce as the route tansitions to the map
      debounce(async () => {
        if (state.mapView) {
          (await state.mapView).when(async () => {
            /* const app = await import("../data/map");
            app.highlightDisplayedDetailsItem(null, state.selectedSearchResultDetail); */
            const features = await app.querySearchItems(
              state.currentSearchItem as any
            );
            await app.selectSearchItems(features);
          });
          //}
        }
      }, 500)();
    }
  };

  const showLocationSearchResult = async () => {
    if (state.mode === "list") {
      navigate("/map");
    }
    debounce(async () => {
      //if (state.mapView) {
      //(await state.mapView).when(async () => {
      const app = await import("../data/map");
      await app.highlightLocationResult(state.locationSearchResults);
      //});
      //}
    }, 500)();
  };

  const createSearchResults = async () => {
    if (state.assessorSearchResults.length !== 0) {
      if (state.mode === "list") {
        //await app.getRelatedParcelData(state.assessorSearchResults, false);
      } else {
        const app = await import("../data/map");
        await app.highlightSearchResults(state.assessorSearchResults, true);
      }
      let items = fetchSearchItems(state.assessorSearchResults);
      if (items) {
        if (items.length === 1) {
          /* setState({
            currentSearchItem: items[0]
          }); */
          setState({
            currentSearchItem: items[0],
            searchResultDetailsItems: items,
            //currentZoomTodisplayedItems: items,
            selectedSearchResultDetail: items[0],
          });
        } else {
          setState({
            searchResultDetailsItems: null,
          });
        }
        setState({ displaySelectionResults: false });
        setState({ searchItems: items });
        setState({ displayedSearchItems: items }); // same initially
        const searchItemLayerNameItems = items
          .map((item) => item.LayerName)
          .filter((value, index, self) => self.indexOf(value) === index);
        setState({ searchItemLayerNames: searchItemLayerNameItems });
        if (searchItemLayerNameItems.length === 1) {
          setState({ displayedSearchItemLayerNames: searchItemLayerNameItems });
        }
      }
    } else {
      setState({ searchItems: [] });
      setState({ displayedSearchItems: [] }); // reset/empty
      setState({ searchItemLayerNames: [] });
    }
  };

  const createSelectResults = async () => {
    if (state.assessorSelectionResults.length !== 0) {
      let items = fetchSelectedItems(state.assessorSelectionResults);
      if (items) {
        if (items.length === 1) {
          setState({
            currentSearchItem: items[0],
            searchResultDetailsItems: items,
          });
        } else {
          setState({
            searchResultDetailsItems: null,
            selectedSearchResultDetail: null,
          });
          highlightDisplayedDetailsItem();
        }

        setState({ displaySelectionResults: true });
        setState({ selectedItems: items });
        setState({ displayedSelectedItems: items });
        //change selecton state for the displayed search items as well in the hook

        const selectedItemLayerNameItems = state.assessorSelectionResults
          .map((item) => item.LayerName)
          .filter((value, index, self) => self.indexOf(value) === index);
        setState({ selectedItemLayerNameItems: selectedItemLayerNameItems });
        if (selectedItemLayerNameItems.length === 1) {
          setState({
            displayedSelectedItemLayerNames: selectedItemLayerNameItems,
          });
        }
      }
    } else {
      setState({ selectedItems: [] });
      setState({ displayedSelectedItems: [] }); // reset/empty
      setState({ selectedItemLayerNameItems: [] });
    }
  };
  const createAssessorDetails = () => {
    let items = state.searchResultDetailsItems;
    setState({ selectedSearchResultDetail: items[0] }); //set the first one
    if (items) {
      if (state.mode === "map") {
        navigate("/list");
      }
    }
  };

  const highlightDisplayedDetailsItem = async () => {
    //if (state.mode === "normal") {
    if (state.mapView) {
      (await state.mapView).when(async () => {
        const app = await import("../data/map");
        app.highlightDisplayedDetailsItem(
          null,
          state.selectedSearchResultDetail
        );
      });
      //}
    }
  };

  const highlightDisplayedSearchItems = async () => {
    if (state.mapView) {
      (await state.mapView).when(async () => {
        //clear selected assessor item and clear map red box too
        if (state.displayedSearchItems.length > 1) {
          setState({
            selectedSearchResultDetail: null,
          });
        }
        const app = await import("../data/map");
        await app.highlightDisplayedSearchItems(state.displayedSearchItems);
      });
    }
  };

  const toggleMapHighlightOnHover = async (show: boolean) => {
    if (state.mode === "normal") {
      const app = await import("../data/map");
      app.toggleMapHighlightOnHover(show, state.mapHoveredHighlightItem);
    }
  };

  useEffect(() => {
    if (state.mapHoveredHighlightItem === null) {
      toggleMapHighlightOnHover(false);
    } else {
      if (state.mapView && state.mapHoveredHighlightItem) {
        toggleMapHighlightOnHover(true);
      }
    }
    return () => {};
  }, [state.mapView, state.mapHoveredHighlightItem]);
  // when an item is selected from the list
  // navigate to the map and select it
  useEffect(() => {
    if (state.currentSearchItem) {
      selectSearchItem();
    }
  }, [state.currentSearchItem]);

  // when the items, latLong or
  // mounted value are true, let's
  // call the nearby method
  useEffect(() => {
    if (state.mounted) {
      setState({ searchItems: searchItems });
    }
  }, [state.mounted]);

  useEffect(() => {
    if (state.assessorSearchResults !== null) {
      createSearchResults();
    }
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, [state.assessorSearchResults]);
  useEffect(() => {
    if (state.assessorSelectionResults !== null) {
      createSelectResults();
    }
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, [state.assessorSelectionResults]);
  useEffect(() => {
    if (state.searchResultDetailsItems !== null) {
      //if (state.searchResultDetailsItems.length === 1) {
      createAssessorDetails();
      //}
    }
    return () => {};
  }, [state.searchResultDetailsItems]);

  

  useEffect(() => {
    if (state.locationSearchResults !== null) {
      showLocationSearchResult();
    }
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, [state.locationSearchResults]);

  useEffect(() => {
    if (
      state.mapView &&
      state.searchItemLayerNames &&
      state.searchItemLayerNames.length > 0
    )
      turnLayersVisible(state.mapView, state.searchItemLayerNames);
    return () => {};
  }, [state.mapView, state.searchItemLayerNames]);
  useEffect(() => {
    //createMapDrawSelectHandle();

    return () => {};
  }, [state.selectionModeOn]);
  useEffect(() => {
    if (state.displayedSearchItems) {
      if (!state.displaySelectionResults) highlightDisplayedSearchItems();
    }
    return () => {};
  }, [
    state.displayedSearchItems || (state.displayedSearchItems && state.mapView),
  ]);
  useEffect(() => {
    highlightDisplayedDetailsItem();
    return () => {};
  }, [
    state.selectedSearchResultDetail ||
      (state.selectedSearchResultDetail && state.mapView),
  ]);
  useEffect(() => {
    if (state.displayedSelectedItems) {
      /* setState({
        selectedSearchResultDetail: null
      }); */
      
      if (state.displayedSelectedItems.length > 0) {
        if (
          state.displayedSearchItems &&
          state.displayedSearchItems.length > 0
        ) {
          //change it here
          const tempdisplayedSearchItems = state.displayedSearchItems;
          tempdisplayedSearchItems.forEach((tempdisplayedSearchItem: any) => {
            tempdisplayedSearchItem.IsSelected = false; //clear first
          });
          state.displayedSelectedItems.forEach((displayedSelectedItem: any) => {
            tempdisplayedSearchItems.forEach((tempdisplayedSearchItem: any) => {
              if (displayedSelectedItem !== undefined) {
                if (
                  tempdisplayedSearchItem.LayerName === operationalLayerName
                ) {
                  if (
                    tempdisplayedSearchItem[assessorInfo.GIS_ID] ===
                    displayedSelectedItem[assessorInfo.GIS_ID]
                  ) {
                    tempdisplayedSearchItem.IsSelected =
                      displayedSelectedItem.IsSelected;
                  }
                } else if (
                  tempdisplayedSearchItem.LayerName ===
                  displayedSelectedItem.LayerName
                ) {
                  let filteredOpLayer = operationalLayers.filter(
                    (opLayer: any, i: number) => {
                      return opLayer.Key === displayedSelectedItem.LayerName;
                    }
                  );
                  if (filteredOpLayer.length !== 0) {
                    if (
                      parseInt(
                        tempdisplayedSearchItem[
                          filteredOpLayer[0].ObjectIDField
                        ].toString()
                      ) ===
                      parseInt(
                        displayedSelectedItem[
                          filteredOpLayer[0].ObjectIDField
                        ].toString()
                      )
                    ) {
                      tempdisplayedSearchItem.IsSelected =
                        displayedSelectedItem.IsSelected;
                    }
                  }
                }
              }
            });
          });
          setState({ displayedSearchItems: tempdisplayedSearchItems });
        }
      } else {
        //clearMapSelection();
        if (
          state.displayedSearchItems &&
          state.displayedSearchItems.length > 0
        ) {
          const tempdisplayedSearchItems = state.displayedSearchItems;
          tempdisplayedSearchItems.forEach((tempdisplayedSearchItem: any) => {
            tempdisplayedSearchItem.IsSelected = false;
          });
          setState({ displayedSearchItems: tempdisplayedSearchItems });
        }
      }
    }
    return () => {};
  }, [state.displayedSelectedItems]);
  const value = {
    state,
    setState,
  };
  useEffect(() => {
    if (state.mapView) {
      if (state.mapBusy) {
        if (document.getElementById("traceMapLoaderImg")) {
          let element = document.getElementById("traceMapLoaderImg");
          element.classList.remove("hidden");
          element.classList.add("visible");
        }
      } else {
        if (document.getElementById("traceMapLoaderImg")) {
          let element = document.getElementById("traceMapLoaderImg");
          element.classList.remove("visible");
          element.classList.add("hidden");
        }
      }
    }
  }, [state.mapView, state.mapBusy]);

  

  //add the page title
  useEffect(() => {
    document.title = ApplicationName;
  }, [state]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
